import styled from 'styled-components';

export const Container = styled.div`
  background-color: var(--v3-black-0);
  border-bottom: 1px solid var(--v3-black-6);
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 0 60px;
  flex-shrink: 0;
  display: flex;
  height: 48px;
  z-index: 10;
  left: 0;
  right: 0;
  top: 0;
`;

export const BackWrapper = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  display: flex;
  padding: 12px;
  align-items: center;
`;

export const Title = styled.span`
  font-size: 18px;
  color: var(--v3-text-color);
  font-weight: 600;
`;

export const Extra = styled.span`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  padding: 12px;
  display: flex;
  align-items: center;
`;
